/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespComplementaryItemsGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
    readonly " $refType": "PdpRespComplementaryItemsGrid_user";
};
export type PdpRespComplementaryItemsGrid_user$data = PdpRespComplementaryItemsGrid_user;
export type PdpRespComplementaryItemsGrid_user$key = {
    readonly " $data"?: PdpRespComplementaryItemsGrid_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespComplementaryItemsGrid_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
(node as any).hash = 'ee3e5955eb96313f940b13f49e4296ec';
export default node;
